// extracted by mini-css-extract-plugin
export default {"loaderWrap":"_loader_loaderWrap__DRG-l","loader":"_loader_loader__bUIYC"};